import { observer } from "mobx-react-lite";

import { useAuthenticatedNavigationContext } from "./AuthenticatedNavigationContext";
import { SaveIndicator } from "./SaveIndicator";

export const NavbarSavingIndicator = observer(function NavbarSavingIndicator() {
  const { saving, hasModalSavingIndicator } =
    useAuthenticatedNavigationContext();

  if (hasModalSavingIndicator) {
    return null;
  }

  return <SaveIndicator status={saving.status} />;
});
